import styled from "styled-components";

export const WrapperContainer = styled.div.attrs({})`
  width: 100%;
  background: transparent;
  padding: ${p => p.wide ? '32px clamp(18px, 3vw, 40px) 56px' : '56px 0 72px clamp(18px, 3vw, 40px)'};
`;

export const WrapperTitle = styled.div.attrs({})`
  font-family: Gilroy;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 6px;
  row-gap: 4px;
  font-size: clamp(28px, 3.4vw, 40px);
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: 0;
  color: ${p => p.theme.palette.colors.text};
  small{
    display: inline-block;
    margin-left: 12px;
    font-size: clamp(18px, 2vw, 22px);
    font-weight: 400;
    letter-spacing: 0;
    color: ${p => p.theme.palette.colors.subdued};
  }
`;
export const BreadcrumbContent = styled.div.attrs({})`
  display: flex;
  align-items: flex-end;
`;

export const BreadcrumbLink = styled.a.attrs({})`
  color: ${p => p.$primary ? p.theme.palette.colors.text : p.theme.palette.colors.subdued};
  font-size: ${p => p.$primary ? 'inherit' : 'clamp(18px, 2vw, 22px)'};
  font-weight: ${p => p.$primary ? 700 : 400};
  line-height: inherit;
  text-decoration: none;
  transition: color 0.2s ease, text-decoration-color 0.2s ease;

  &:hover,
  &:focus-visible {
    color: ${p => p.theme.palette.colors.primary};
    text-underline-offset: 4px;
  }
`;
export const BreadcrumbCurrent = styled.span.attrs({})`
  color: ${p => p.$primary ? p.theme.palette.colors.text : p.theme.palette.colors.subdued};
  font-size: ${p => p.$primary ? 'inherit' : 'clamp(18px, 2vw, 22px)'};
  font-weight: ${p => p.$primary ? 700 : 400};
  line-height: inherit;
`;
export const BreadcrumbSeparator = styled.span.attrs({})`
  color: ${p => p.theme.palette.colors.subdued};
  font-size: clamp(18px, 2vw, 22px);
  font-weight: 400;
  line-height: inherit;
`;
export const WrapperSection = styled.div.attrs({})`
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.12em;
  color: ${p => p.theme.palette.colors.subdued};
  text-transform: uppercase;
`;
export const WrapperContent = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${p => p.between ? `
    width: 100%;
  ` : ''};
`;
export const ButtonContainer = styled.div.attrs({})`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  @media(max-width: 991px) {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  width: 100%;

  @media(max-width: 560px) {
    width: 100%;

    > * {
      width: 100%;
    }
  }
`;

export const WrapperHeader = styled.div.attrs({})`
  display: flex;
  gap: 24px;
  justify-content: space-between;
  align-items: flex-end;
  ${p => p.wide ? 'padding-right: 0px' : 'padding-right: 32px;'};
  padding: 0 0 32px;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
  margin-bottom: 28px;

  @media(max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    ${p => p.wide ? 'padding-right: 0;' : 'padding-right: 18px;'};
  }
`;

export const RenderOptionContent = styled.div.attrs({})`
  display: flex;
  border-radius: 999px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  background: ${p => p.theme.palette.secondary.main};
  padding: 3px;
  height: 48px;
  flex-shrink: 0;
  width: fit-content;
  box-shadow: 0 12px 30px ${p => p.theme.palette.colors.shadowStrong};
`;

export const RenderOption = styled.div.attrs({})`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 44px;
  flex-shrink: 0;
  border-radius: 999px;
  background: ${p => p.active ? p.theme.palette.colors.badgeMuted : 'transparent'};
  cursor: pointer;
  transition: transform 0.22s ease, background 0.22s ease;

  &:hover {
    transform: translateY(-1px);
  }
`;

export const SelectContainer = styled.div.attrs({})`
  min-height: 42px;
  width: clamp(140px, 18vw, 180px);
  margin-top: -16px;

  @media(max-width: 560px) {
    width: 100%;
  }
`;

export const ShareButtonGroup = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;

  .MuiButton-root {
    flex: 0 0 auto;
    min-width: 88px;
    max-width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    white-space: nowrap;
  }

  .MuiButton-contained img {
    filter: brightness(0) invert(1);
  }

  @media(max-width: 760px) {
    flex-wrap: wrap;
  }

  @media(max-width: 560px) {
    width: 100%;

    .MuiButton-root {
      flex: 1 1 min(180px, 100%);
      width: auto;
    }
  }
`;
